import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/89d42673-7285-47cc-8d65-dc82189fdfdf";
export const REGISTER_URL = "https://a.ntrk2.com/16b9dcaf-6904-43ff-907f-ff5b51c8c70c";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://getbr.kzw2a.com/download?openExternalBrowser=1&id=kfqjjq27lzakznr";

export * from "./codes";
export * from "./context";
